import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=3288d3fa&scoped=true"
import script from "./certificate.vue?vue&type=script&lang=js"
export * from "./certificate.vue?vue&type=script&lang=js"
import style0 from "./certificate.vue?vue&type=style&index=0&id=3288d3fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3288d3fa",
  null
  
)

export default component.exports